import React, {FC} from "react"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {NotificationCount, NotificationContainer} from "./styled"

interface Props {
  isDisplayed: boolean,
  count: number
}

const NotificationBell: FC<Props> = ({isDisplayed, count}) => {
  return (
    <NotificationContainer isMenuDisplayed={isDisplayed}>
      <Icon icon={isDisplayed ? IconTypes.notificationFilled : IconTypes.notificationBold} size={24} />
      {!isDisplayed && count > 0 && <NotificationCount>{count}</NotificationCount>}
    </NotificationContainer>
  )
}

export default NotificationBell
